<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { makeCamera } from '@parkingboss/barcam';

  const dispatch = createEventDispatcher();

  async function fileChanged(evt) {
    const frame = evt.target.files[0];
    const result = camera.detectBarcode({ frame });
    dispatch('barcode', result);
  }

  let parent = null;
  let camera = null;

  onMount(() => {
    let cancelled = false;
    let stopWatching = null;

    makeCamera(parent).then(cam => {
      if (cancelled) return;

      camera = cam;
      if (camera.video) {
        stopWatching = camera.detectAllBarcodes(result => dispatch('barcode', result));
      }
    });

    return () => {
      cancelled = true;
      if (stopWatching) stopWatching();
      if (camera) camera.remove();
    };
  });
</script>

<figure class="camera" bind:this={parent} class:loading={!camera} class:video={camera && camera.video}>
  {#if parent && camera && !camera.video}
    <input type='file' accept='image/*' capture='environment' on:change={fileChanged} />
  {/if}
</figure>
